"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/builtin/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _RadioGroup.default;
  }
});

var _RadioGroup = _interopRequireDefault(require("./RadioGroup"));


/*****************
 ** WEBPACK FOOTER
 ** ./~/@material-ui/core/RadioGroup/index.js
 ** module id = 907
 ** module chunks = 0
 **/